<script>
export default {
  name: 'ColTableBody',
  props: ['data', 'rows', 'columnWidth'],
  data() {
    return {}
  },
  render(createElement) {
    return createElement(
      'div',
      {
        class: ['col-table__content']
      },
      this.rows.map((row) => {
        return createElement(
          'div',
          {
            class: ['col-table__row', ...row.rowClass]
          },
          [
            createElement(
              'div',
              {
                class: ['col-table__td', 'col-table__td--header'],
                style: row.rowStyle
              },
              [row.headerCellSlot.call(null, createElement, row)]
            ),
            this.data.map((item) => {
              return createElement(
                'div',
                {
                  class: ['col-table__td', 'col-table__td--body'],
                  style: { width: this.columnWidth + 'px', ...row.rowStyle }
                },
                [row.bodyCellSlot.call(null, createElement, { row: item })]
              )
            })
          ]
        )
      })
    )
  }
}
</script>
